import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import HCaptcha from "@hcaptcha/react-hcaptcha";
import { ConfigContext, Modal } from "@pionex-web-kit/components";
import React, { useContext } from "react";
import { fromPromise } from "rxjs/internal-compatibility";
import { jsx as _jsx } from "react/jsx-runtime";
function HCaptchaRender(props) {
  var _useContext = useContext(ConfigContext),
    theme = _useContext.theme;
  return /*#__PURE__*/_jsx("div", {
    children: /*#__PURE__*/_jsx(HCaptcha, _objectSpread(_objectSpread({
      theme: theme
    }, props), {}, {
      reCaptchaCompat: false
    }))
  });
}
function requestHCaptchaPromise(params) {
  return new Promise(function (resolve, reject) {
    var modal = Modal.info({
      maskClosable: true,
      className: "pi-hcaptcha-provider-modal",
      width: "auto",
      footer: null,
      mobileSwitch: false,
      content: /*#__PURE__*/_jsx(HCaptchaRender, {
        languageOverride: params.lang,
        sitekey: params.siteKey,
        onVerify: function onVerify(captcha_token, e_key) {
          resolve({
            captcha_token: captcha_token,
            e_key: e_key
          });
          setTimeout(function () {
            modal.destroy();
          }, 200);
        },
        onClose: function onClose() {
          modal.destroy();
          reject({
            code: -10,
            message: "HCaptcha cancel"
          });
        },
        onExpire: function onExpire() {
          modal.destroy();
          reject({
            code: -10,
            message: "HCaptcha expires"
          });
        }
      }),
      onCancel: function onCancel() {
        reject({
          code: -10,
          message: "HCaptcha cancel"
        });
      }
    });
  });
}
export function requestHCaptcha(params) {
  return fromPromise(requestHCaptchaPromise(params));
}